import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {IntlProvider} from "react-intl";
import en from "./localization/en.json";
import fr from "./localization/fr.json";

const data = {
  "en":en,
  "fr":fr
}

let focusing, inside = true;
const urlParams = new URLSearchParams(window.location.search);
let language = localStorage.getItem("lang") || navigator.language.split(/[-_]/)[0];
if (urlParams.get("lang")) {
  language = urlParams.get("lang")
  localStorage.setItem("lang", language);
}
if (!data[language]) {
  language="en";
}
if (language === "fr") {
  document.title = "Rémy Jeuniaux - Graphiste"
  document.querySelector("footer > div").innerHTML="<span>Rémy | Graphiste</span><a class='sitemapLink' href='/remyjeuniaux/sitemap'>Plan du site</a><span>© 2022 Rémy Jeuniaux<br/>Site web réalisé par Saison</span>";
  document.querySelector("footer > span").innerHTML="<span class='optimizeMobile'>See website in </span><span class='portfolioLink minimal'><span class='displayMobile'>→ </span><a href='./?lang=en'>English</a></span>";
}

function update(e){
  const revealArea = e.target.closest('.reveal-area');
  if (revealArea) {
    document.documentElement.style.setProperty('--cursorX', e.clientX + 'px');
    document.documentElement.style.setProperty('--cursorY', e.clientY + 'px');
    focusing = true;
    const target = e.target.closest('.reveal');
    if (target) {
      inside = true;
      const rect = target.getBoundingClientRect();
      document.documentElement.style.setProperty('--focus-scale', 1);
      document.documentElement.style.setProperty('--focus-height', rect.height + 'px');
      document.documentElement.style.setProperty('--focus-width', rect.width + 'px');
      document.documentElement.style.setProperty('--focus-anim', 'revealHighlight 0.4s forwards');
      document.documentElement.style.setProperty('--focus-path', `inset(${rect.top}px ${window.innerWidth - rect.right}px ${window.innerHeight - rect.bottom}px ${rect.left}px round ${target.classList.contains("round") ? "var(--round-radius)" : "var(--focus-radius)"})`);
    } else {
      if (!inside) return;
      inside = false;
      document.documentElement.style.setProperty('--focus-scale', 0.3);
      document.documentElement.style.setProperty('--focus-height', '100%');
      document.documentElement.style.setProperty('--focus-width', '100%');
      document.documentElement.style.setProperty('--focus-anim', 'unset');
      document.documentElement.style.setProperty('--focus-path', 'unset');
    }
  } else {
    if (!focusing) return;
    inside = true;
    document.documentElement.style.setProperty('--focus-scale', 0);
    focusing = false;
  }
}
function leave() {
  if (!focusing) return;
  document.documentElement.style.setProperty('--focus-scale', 0);
  focusing = false;
}

document.addEventListener('mousemove', update);
document.addEventListener('click', leave);
document.addEventListener('mouseleave', leave);

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale={language} messages={data[language]}>
      <App/>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
